/** Customer context (M29): mirror of backend `app/core/constants/customer_context.py`.
 *  `backend/tests/core/test_m29_constants_mirror.py` keeps the two equal (a drift either way fails).
 *  The customer reference is shown masked; it never goes in a URL, a log or an error message. */

export const ACCOUNT_STATUS_VALUES = ["active", "restricted", "suspended", "self_excluded", "closed", "kyc_pending"] as const;
export type AccountStatus = (typeof ACCOUNT_STATUS_VALUES)[number];

export const CONTEXT_SOURCE_VALUES = ["launch", "context_api", "signed_event", "connector_sync", "console"] as const;
export type ContextSource = (typeof CONTEXT_SOURCE_VALUES)[number];

export const CUSTOMER_REF_MIN = 1 as const;

export const CUSTOMER_REF_MAX = 128 as const;

export const CUSTOMER_REF_PATTERN = "^[A-Za-z0-9._:-]{1,128}$" as const;

export const CUSTOMER_REF_VISIBLE_CHARS = 4 as const;

export const CUSTOMER_REF_KEYS = ["ref", "customer_ref"] as const;

export const TIER_PATTERN = "^[a-z0-9_]{1,32}$" as const;

export const TIER_MAX = 32 as const;

export const CONTEXT_ATTRIBUTES_MAX = 20 as const;

export const CONTEXT_DISPLAY_NAME_MAX = 60 as const;

export const CONTEXT_LOCALES = ["en", "fil"] as const;

/** Keys only the operator may set (never a visitor through `identify` / `visitors/*`). */
export const CONTEXT_RESERVED_KEYS = ["ref", "customer_ref", "tier", "account_status"] as const;

export const CONTEXT_AS_OF_FUTURE_SKEW_S = 300 as const;

/** The staff card calls context older than this stale. */
export const CONTEXT_STALE_AFTER_S = 86400 as const;

export const CONTEXT_PROPAGATION_TARGET_S = 5 as const;

export const CONTEXT_HISTORY_RETENTION_DAYS = 365 as const;

export const CONTEXT_HISTORY_RETENTION_CLASS = "customer_context_history" as const;
